module.exports = __webpack_public_path__ + "media/images/project-2-47e856b1d97a8995660dde55c1f3866d.png";